import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  topNavigation: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  topNavigationParent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  topNavigationLeft: {
    textAlign: 'left',
  },
  topNavigationRight: {
    textAlign: 'right',
  },
  divider: {
    marginBottom: tokens.spacingVerticalL,
  },
  recommendedImage: {
    marginBottom: tokens.spacingVerticalL,
  },
});
